import gql from "graphql-tag";

export const DELETE_TODO_MUTATION = gql`
  mutation deleteTodoMutation($todoId: ID!, $userId: ID!) {
    deleteTodoMutation(todoId: $todoId, userId: $userId) {
      success
      error
    }
  }
`;

export const UPSERT_TODO_MUTATION = gql`
  mutation upsertTodoMutation($data: TodoInput!) {
    upsertTodoMutation(data: $data) {
      success
      created
      error
    }
  }
`;
